"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = References;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _saraivaUi = require("@minha-biblioteca/saraiva-ui");
var _core = require("@material-ui/core");
var _FileCopyOutlined = _interopRequireDefault(require("@material-ui/icons/FileCopyOutlined"));
var _styles = _interopRequireDefault(require("./styles"));
var _index = require("../../utils/index");
var _Trackings = _interopRequireDefault(require("../../services/Trackings"));
var _Copy = require("../../constants/Copy");
var _Auth = require("../../contexts/Auth");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function References(_ref) {
  var {
    reference,
    pdf,
    copyValue
  } = _ref;
  var {
    auth
  } = (0, _Auth.useAuth)();
  var trackService = (0, _Trackings.default)(auth);
  var classes = (0, _styles.default)();
  var [snackBar, setSnackBar] = (0, _react.useState)(false);
  var matches = (0, _core.useMediaQuery)('(min-width:770px)');
  var trackingReferenceCopy = () => {
    trackService.trackReferenceCopy({
      origin: _Copy.ORIGIN.READER
    });
  };
  var copyToClipBoard = () => {
    trackingReferenceCopy();
    setSnackBar(true);
    var content = "".concat((0, _index.stripHtmlTags)(reference), ". Ebook.");
    navigator.clipboard.writeText(content);
    setTimeout(() => {
      setSnackBar(false);
    }, 5000);
  };
  var handleKeyDown = event => {
    event.preventDefault();
    var charCode = String.fromCharCode(event.which).toLowerCase();
    if ((event.ctrlKey || event.metaKey) && charCode === 'c') {
      trackingReferenceCopy();
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "reader-references",
    className: matches ? classes.root : classes.rootMobile
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.top
  }, /*#__PURE__*/_react.default.createElement("h6", {
    className: matches ? classes.title : classes.titleMobile
  }, "Refer\xEAncia bibliogr\xE1fica"), matches ? /*#__PURE__*/_react.default.createElement(_saraivaUi.Button, {
    className: classes.copyBtn,
    color: "secondary",
    onClick: copyToClipBoard,
    startIcon: /*#__PURE__*/_react.default.createElement(_FileCopyOutlined.default, null)
  }, matches ? 'Copiar' : null) : /*#__PURE__*/_react.default.createElement(_FileCopyOutlined.default, {
    role: "button",
    onClick: copyToClipBoard,
    color: "secondary"
  })), /*#__PURE__*/_react.default.createElement("div", {
    onKeyDown: handleKeyDown,
    contentEditable: Boolean(true),
    spellCheck: "false",
    className: matches ? classes.reference : classes.referenceMobile,
    id: "abnt-text"
    /* eslint-disable-next-line react/no-danger */,
    dangerouslySetInnerHTML: {
      __html: "".concat((0, _index.formatAbntText)(reference), ". <em>Ebook</em>.")
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: matches ? classes.divider : classes.dividerMobile
  }), /*#__PURE__*/_react.default.createElement("h6", {
    className: matches ? classes.label : classes.labelMobile
  }, "Limite de c\xF3pia deste livro"), copyValue ? /*#__PURE__*/_react.default.createElement(_saraivaUi.ProgressBar, {
    className: classes.bar,
    size: "full",
    color: "secondary",
    comment: "A copia de conte\xFAdo deste livro \xE9 limitada e n\xE3o deve ser utilizada para fins comerciais.",
    small: true,
    limit: true,
    value: copyValue
  }) : /*#__PURE__*/_react.default.createElement(_saraivaUi.ProgressBar, {
    className: classes.bar,
    size: "full",
    color: "secondary",
    comment: "A copia de conte\xFAdo deste livro \xE9 limitada e n\xE3o deve ser utilizada para fins comerciais.",
    small: true,
    limit: true,
    value: 0
  }), snackBar && /*#__PURE__*/_react.default.createElement("div", {
    className: matches ? classes.snackBar : classes.snackBarMobile
  }, /*#__PURE__*/_react.default.createElement(_saraivaUi.Snackbar, {
    severity: "success",
    noClose: true,
    show: snackBar
  }, "Refer\xEAncia bibliogr\xE1fica copiada para \xE1rea de transfer\xEAncia.")));
}
References.propTypes = {
  reference: _propTypes.default.string.isRequired
};